import { createFileRoute } from "@tanstack/react-router";
import DigitalWorkers from "@/pages/DigitalWorkers";
import { pageHead } from "@/lib/seo";
import { agentsItemListJsonLd } from "@/lib/agents";

export const Route = createFileRoute("/th/digital-workers")({
  head: () => ({
    ...pageHead("/digital-workers", "th"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(agentsItemListJsonLd("th")),
      },
    ],
  }),
  component: DigitalWorkers,
});
